/**
 * @description 通用方法集合
 */

/**
 * @description 下拉选择“全部”的key值
 */
export const AllId = 'all';

/**
 * @description 选择“全部”后，接口的入参的占位地域 @TODO 待讨论，忽略地域时，传什么值，涉及到openApi侧的拼参
 */
export const PlaceholderIdc = 'cn-north-1';

/**
 * @description 相关get请求（例如：带宽菜单-带宽列表请求接口api/resource/listBandwidths）， 接口入参ignoreIdc根据idc的值，做转化,如果idc=all,则新增入参ignoreIdc=1
 * @param {String} selectRoom - selectRoom 选择地域
 * @example idc=all (表示选择全部地域)，接口入参新增ignoreIdc=1（表示忽略根据idc做筛选）
 */
export function handleChangeAllSelectedValue (selectRoom) {
  if (selectRoom === AllId) {
    return {
      ignoreIdc: 1, // 1为忽略 0为不忽略
      idc: PlaceholderIdc, // @TODO 待讨论，忽略地域时，传什么值，涉及到openApi侧的拼参
    }
  }
  return {}
}

/**
 * @description 下拉选项，选择“全部”的key value值
 */
export function AllSelectOption (that, idc, idcName) {

  return {
    [idc]: AllId,
    [idcName]: that.$t('ticket.complete') || '全部',
  }
}



// WEBPACK FOOTER //
// ./src/utils/common/index.js